<div class="grid-container">
<create-password [createMode]="true" *ngIf="resetPasswordView" (resetPasswordCompleted)="resetPasswordCompleted($event)"></create-password>
<app-user-profile-edit *ngIf="!resetPasswordView" [user]="user" [signUpMode]="true" (editProfileCompleted)="completeSignUp()"></app-user-profile-edit>
</div>
